/**
 * SelectionActionBar
 *
 * Floating action bar that appears when properties are selected.
 * Shows selected count and delete action button.
 */

import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ISelectionActionBarProps } from '@/@types/property';

export const SelectionActionBar = ({
  selectedCount,
  onDelete,
  isDeleting = false,
}: ISelectionActionBarProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-4 px-6 py-3 bg-gray-900 dark:bg-gray-800 text-white rounded-full shadow-lg border border-gray-700">
        <span className="text-sm font-medium">
          {selectedCount} selected
        </span>
        <div className="w-px h-4 bg-gray-600" />
        <Button
          variant="destructive"
          size="sm"
          onClick={onDelete}
          disabled={isDeleting}
          className="gap-2"
        >
          <Trash2 className="h-4 w-4" />
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </div>
    </div>
  );
};
